/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { InvoiceRenderPdfPathParams, InvoiceRenderPdfResponse } from '../types/InvoiceRenderPdf'

/**
 * GET /:organisation/invoices/:invoice/pdf
 * @see backend/nexus/modules/Billing/Http/Controllers/InvoiceController.php InvoiceController::renderPdf
 */
export async function invoiceRenderPdf(
	organisation: InvoiceRenderPdfPathParams['organisation'],
	invoice: InvoiceRenderPdfPathParams['invoice'],
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<InvoiceRenderPdfResponse>> {
	return axiosInstance.get(`/${organisation}/invoices/${invoice}/pdf`, config)
}
